export enum UserType {
    none = 0,
    User = 1,
    Admin = 2,
    SuperTeacher = 3,
    Teacher = 4,
    Student = 8,
    Parent = 16,
    ProgramAdmin = 32,
    ProgramUser = 64,
    Guest = 128,
    SuperAdmin = 264,
    GroupUser = 512
}
